import React from 'react';
import { connect } from 'react-redux';
import {
  IconMenu,
  Divider,
  MenuItem,
  FontIcon,
  RaisedButton,
} from 'material-ui';
import DownloadAll from 'material-ui/svg-icons/action/get-app';
import SentIcon from 'material-ui/svg-icons/content/send';
import ArchivedIcon from 'material-ui/svg-icons/content/archive';

import { getStatusIcon, getStatusColor } from '../contractingUtils';
import { openUpgradeFrom as openUpgradeFromAction } from '../../../stores/ui/components/upgrade/upgrade-actions';
import ExportTourWriter from '../generic-components/exportTourWriter.jsx';
import WallWrapper from '../../wall/wrapper';

const BulkActions = ({
  downloadPdfZip,
  extraPropsForIconMenu,
  isFolder,
  moveToArchived,
  moveToTrash,
  openBulkResendDialog,
  openManageFolderDialog,
  resourceType,
  routeName,
  stateChange,
  unselectAll,
}) => {
  const inContractRequest = (resourceType === 'Contractor' && routeName === 'sent') || (resourceType === 'Supplier' && routeName === 'recent');
  return (
    <div>
      <IconMenu
        iconButtonElement={(
          <RaisedButton
            label="Bulk Actions"
            style={{ marginRight: '6px' }}
            secondary
          />
        )}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        {...extraPropsForIconMenu}
        desktop
      >
        <MenuItem
          leftIcon={<DownloadAll />}
          primaryText="Download All"
          onTouchTap={downloadPdfZip}
          disabled={inContractRequest}
        />
        <Divider />
        {resourceType === 'Contractor' ? (
          <MenuItem
            leftIcon={<FontIcon className={getStatusIcon('accepted')} color={getStatusColor('accepted')} />}
            primaryText="Mark All as Accepted"
            onTouchTap={() => {
              stateChange('accepted');
              unselectAll();
            }}
          />
        ) : <span />}
        {resourceType === 'Contractor' ? (
          <MenuItem
            leftIcon={<FontIcon className={getStatusIcon('loading')} color={getStatusColor('loading')} />}
            primaryText="Mark All as Loading"
            onTouchTap={() => {
              stateChange('loading');
              unselectAll();
            }}
          />
        ) : <span />}
        {resourceType === 'Contractor' ? (
          <MenuItem
            leftIcon={<FontIcon className={getStatusIcon('loaded')} color={getStatusColor('loaded')} />}
            primaryText="Mark All as Loaded"
            onTouchTap={() => {
              stateChange('loaded');
              unselectAll();
            }}
          />
        ) : <span />}
        {resourceType === 'Contractor' ? (
          <MenuItem
            leftIcon={<FontIcon className={getStatusIcon('rejected')} color={getStatusColor('rejected')} />}
            primaryText="Mark All as Rejected"
            onTouchTap={() => {
              stateChange('rejected');
              unselectAll();
            }}
          />
        ) : <span />}
        {resourceType === 'Contractor' ? <Divider /> : <span />}
        <MenuItem
          disabled={routeName === 'recent'}
          primaryText={`Resend ${resourceType === 'Contractor' ? 'Requests' : 'Contracts'}`}
          onTouchTap={openBulkResendDialog}
          leftIcon={<SentIcon color="rgba(0, 0, 0, 0.67)" />}
        />
        <Divider />
        <WallWrapper amazonOrange skipClick>
          <MenuItem
            leftIcon={<FontIcon className="tc-icon-create_new_folder" color="#00bcd4" />}
            primaryText="Assign Folders"
            onTouchTap={openManageFolderDialog('assign')}
          />
        </WallWrapper>
        {
          isFolder && (
            <MenuItem
              leftIcon={<FontIcon className="tc-icon-folder_open" />}
              primaryText="Move Out of Folder"
              onTouchTap={openManageFolderDialog('moveOut')}
            />
          )
        }
        <Divider />
        <MenuItem
          leftIcon={<ArchivedIcon />}
          primaryText="Move to Archived"
          onTouchTap={moveToArchived}
        />
        <MenuItem
          leftIcon={<FontIcon className="tc-icon-delete2" color="#ff4081" />}
          primaryText="Move to Trash"
          onTouchTap={moveToTrash}
        />
        <ExportTourWriter />
        <ExportTourWriter blackout />
      </IconMenu>
    </div>
  );
};
const mapStateToProps = ({ user, contracting }) => ({
  resourceType: user.getIn(['user', 'type']),
  billingPlan: user.get('billingPlan'),
  folders: contracting.contractList.get('folders').toJS(),
  routeName: contracting.contractList.getIn(['list', 'listType']),
  isFolder: contracting.contractList.get('isFolder'),
  searchCategory: contracting.contractList.get('searchCategory') || '',
});
export default connect(mapStateToProps, {
  openUpgradeFrom: openUpgradeFromAction,
})(BulkActions);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/bulk-actions.jsx